export const apiBaseUrl = process.env.REACT_APP_API_BASE_URL

export const apiPaths = {
    auth: "/auth",
    versions: "/versions",
    results: "/dashboard/results",
    create: "/dashboard/create",
    update: "/dashboard/update",
    dashboardVersion: "/dashboard",
    displayType: "/display-types"
}